'use client';

import { LinkContext, type Routes } from '@lichtblick/link/helpers/link-context';
import type { FC, PropsWithChildren } from 'react';

const APP_ROUTES: Routes = {
  externalRoutes: {
    absolute: [
      '/bestandskunden/checkout/adresse/',
      '/bestandskunden/checkout/oekogas/',
      '/bestandskunden/checkout/oekostrom-und-oekogas/',
      '/bestandskunden/checkout/oekostrom/',
      '/bestandskunden/waermestrom-checkout/',
      '/bestandskunden/waermestrom-checkout/adresse/',
    ],
    catchAll: [],
  },
  internalRoutes: {
    absolute: [],
    catchAll: [
      '/bestandskunden/',
      '/checkout/',
      '/oekostrom-vario-checkout/',
      '/registrierung-abschliessen/',
      '/das-klima-dankt/',
      '/waermestrom-checkout/',
      '/oekostrom-dynamic/',
    ],
  },
};

export const LinkContextProvider: FC<PropsWithChildren> = ({ children }) => (
  <LinkContext.Provider value={APP_ROUTES}>{children}</LinkContext.Provider>
);
